export enum BridgeAppraisalStatus {
    NothingReceived = 0,
    PaymentReceived = 1,
    SurveyReceived = 2,
    PaymentAndSurveyReceived = 3,
    ReadyForAppraisal = 4,
    AppraisalOrdered = 5,
    Appraised = 6,
    ApprovedAndWaitingToClose = 7,
    Closed = 8,
}
